import { any } from 'prop-types'
import { useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom'
import InternalServerError from './InternalServerError'
import Loading from './Loading'
const Login = ({ children = 'No content' }) => {
	const status = useSelector(state => state?.user?.STATUS)
	const role = useSelector(state => state?.user?.user?.user_type)
	return status === 'LOADING' ? (
		<Loading />
	) : status === 'SERVER_ERROR' ? (
		<InternalServerError />
	) : status === 'ERROR' ? (
		children
	) : role === 'admin' || role === 'accountant' ? (
		<Navigate to='/account/dashboard' />
	) : (
		<Navigate to='/account/groups' />
	)
}
Login.propTypes = {
	children: any,
}
export default Login
